
import { defineComponent, ref, computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { usePopupStore } from '@/store/popup'
import { useDicomStore } from '@/store/dicom'
import { useLoginStore } from '@/store/login';

export default defineComponent({
  components: {
  },
  props:{
  },
  setup(props, {emit}) {
    const router = useRouter();
    const popupStore = usePopupStore();
    const dicomStore = useDicomStore();

    const closePopup = () => {
      popupStore.togglePopup('sessionConflict', false);
    }

    const handleConfirmClick = () => {
      closePopup();
      useLoginStore().removeToken();
      router.push({ name: 'login' });
    }

    onMounted(() => {
    });

    return {
      closePopup,
      handleConfirmClick
    };
  },
});
